<template>
<div id="mobileheads">
    <nav id="mobileitems" aria-label="Основная навигация">
        <router-link
            v-for="item in navigationItems"
            :id="item.id"
            :key="item.key"
            :to="item.to"
            :class="{ 'mobileitem-active': activeNavKey === item.key }"
            :aria-current="navAriaCurrent(item)"
            class="mobileitem"
        >
            <MobileNavIcon :name="item.key" :filled="activeNavKey === item.key"/>
            <span>{{ item.label }}</span>
        </router-link>
    </nav>
</div>
</template>

<script>
import MobileNavIcon from '@/components/Headers/MobileNavIcon.vue'

const NAVIGATION_ITEMS = Object.freeze([
    { key: 'home', label: 'Главная', to: '/', id: 'mobilehomepage' },
    { key: 'catalog', label: 'Каталог', to: '/catalog', id: 'mobilecatalogpage' },
    { key: 'library', label: 'Библиотека', to: '/library', id: 'mobilelibrarypage' },
    { key: 'search', label: 'Поиск', to: '/search', id: 'mobilesearch' },
    { key: 'schedule', label: 'Расписание', to: '/schedule', id: 'mobileschedule' },
])

export default {
    name: 'MobileHeader',
    components: { MobileNavIcon },
    data() {
        return {
            navigationItems: NAVIGATION_ITEMS,
        }
    },
    computed: {
        activeNavKey() {
            return this.$route.meta.nav
        }
    },
    methods: {
        navAriaCurrent(item) {
            if (this.activeNavKey !== item.key) return undefined
            return this.$route.path === item.to ? 'page' : 'location'
        },
    }
}
</script>

<style scoped>


#mobileheads {
    position: fixed;
    background: rgba(7, 7, 7, 0.96);
    width: 100%;
    height: 60px;
    box-sizing: content-box;
    padding-bottom: max(16px, env(safe-area-inset-bottom, 0px));
    bottom: 0;
    left: 0;
    z-index: 15;
    display: flex;
    border-top: 1px solid rgb(32, 32, 32);
}
#mobileitems {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: stretch;
    padding-left: max(8px, env(safe-area-inset-left, 0px));
    padding-right: max(8px, env(safe-area-inset-right, 0px));
    margin-left: auto;
    margin-right: auto;
    margin-top: 0;
    margin-bottom: 0;
}
.mobileitem {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 4px;
    box-sizing: border-box;
    padding: 0 2px;
    color: rgba(255, 255, 255, 0.65);
    font-size: clamp(11px, 3.4vw, 14px);
    font-family: Inter, sans-serif;
    font-weight: 500;
    line-height: 1;
    position: relative;
    cursor: pointer;
    text-decoration: none;
    transition: color 160ms ease, opacity 160ms ease;
}
.mobileitem-active {
    color: #fff;
    font-weight: 650;
}
.mobileitem:focus-visible {
    outline: 2px solid #fff;
    outline-offset: -4px;
    border-radius: 10px;
}
@media (min-width: 1001px) {
    #mobileheads {
        display: none;
    }
}
@media (prefers-reduced-motion: reduce) {
    .mobileitem,
    .mobile-nav-icon {
        transition: none;
    }
}
</style>
